import { Component } from "@angular/core";
import { CommunicatorService, MyServiceEvent, ActiveClient } from './services/communication.service';
import { LoaderService } from './loader/loader.service';
import { NoAutofillGlobalService } from './shared/no-autofill/no-autofill-global.service';
import { MatSnackBar } from '@angular/material/snack-bar';

import {
  Event,
  Router,
  NavigationStart,
  NavigationEnd,
  RouterEvent
} from "@angular/router";
import { PlatformLocation } from "@angular/common";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"]
})
export class AppComponent {
  currentUrl: string;
  showLoadingIndicatior = true;

  // E: suppress duplicate SN-invalid toasts per port — the service may emit on
  // every Parameters frame while the device is misreading the serial.
  private lastSNInvalidToast: { [portindex: number]: number } = {};
  private readonly SN_TOAST_DEBOUNCE_MS = 10000;

  constructor(public _router: Router, location: PlatformLocation, private Comm: CommunicatorService, public loaderService: LoaderService,
    private noAutofill: NoAutofillGlobalService, private snackBar: MatSnackBar) {

   console.clear();

    // Stop browser password autofill on every password field (authentication pages are skipped)
    this.noAutofill.start();

    this._router.events.subscribe((routerEvent: Event) => {
      if (routerEvent instanceof NavigationStart) {
        this.showLoadingIndicatior = true;
        

        location.onPopState(() => {
          window.location.reload();
        });
        this.currentUrl = routerEvent.url.substring(
          routerEvent.url.lastIndexOf("/") + 1
        );
      }
      if (routerEvent instanceof NavigationEnd) {
        this.showLoadingIndicatior = false;
      }
      window.scrollTo(0, 0);
    });


    console.log("Start Applicaiton")

    // E: translate invalid-SN events emitted by CommunicatorService into a
    // user-visible snackbar. The service already blocks the Firestore write;
    // without this handler the operator would never see that it was blocked.
    this.Comm.onChange.subscribe({
      next: (event: MyServiceEvent) => {
        switch (event.command) {

          case 'isSNValid':
            if (event.value === 1) {
              this.showSNToast(
                event.portindex,
                `Device on port ${event.port}: invalid serial number — writes to Firebase are blocked until a valid serial is read.`,
                'red',
              );
            }
            break;

          case 'DeviceWriteSkipped':
            this.showSNToast(
              event.portindex,
              `Save blocked — device on port ${event.port} has no valid serial number yet.`,
              'red',
            );
            break;

        }
      }
    });


  }

  private showSNToast(portindex: number, text: string, panelClass: string): void {
    const now = Date.now();
    const last = this.lastSNInvalidToast[portindex] || 0;
    if (now - last < this.SN_TOAST_DEBOUNCE_MS) {
      return;
    }
    this.lastSNInvalidToast[portindex] = now;

    this.snackBar.open(text, 'Dismiss', {
      duration: 5000,
      verticalPosition: 'bottom',
      horizontalPosition: 'right',
      panelClass: panelClass,
    });
  }





}
